/**
 * Nice Shot facets — AJAX filtering + sort + drawer for collection AND search.
 *
 * Works with any section that carries [data-ns-facets-root] + data-section-id
 * + data-base-url (ns-collection, ns-search). Uses the Section Rendering API
 * (?section_id=...) so a filter tick swaps the grid in place — no full page
 * reload (the #1 catalog UX lever on mobile).
 *
 * All handlers are delegated to document so the section's inner HTML can be
 * swapped freely without rebinding.
 */
(function () {
  if (window.__nsFacets) return;
  window.__nsFacets = true;

  var controller = null;
  var priceTimer = null;
  var lastFocusedOpener = null;

  function getRoot(el) {
    return el && el.closest ? el.closest('[data-ns-facets-root]') : null;
  }

  function pageRoot() {
    return document.querySelector('[data-ns-facets-root]');
  }

  function serializeForm(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    return params;
  }

  function fetchAndSwap(root, params, push) {
    var sectionId = root.getAttribute('data-section-id');
    var base = root.getAttribute('data-base-url') || window.location.pathname;
    var qs = params ? params.toString() : '';
    var displayUrl = base + (qs ? '?' + qs : '');
    var fetchUrl = base + '?' + (qs ? qs + '&' : '') + 'section_id=' + encodeURIComponent(sectionId);

    if (controller) controller.abort();
    controller = new AbortController();
    root.setAttribute('aria-busy', 'true');

    fetch(fetchUrl, { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ns-facets-root]');
        if (!fresh) {
          window.location.href = displayUrl;
          return;
        }

        // Preserve which facet groups are open across the swap
        var openLabels = [];
        root.querySelectorAll('.ns-coll__facet[open] .ns-coll__facet-summary span:first-child').forEach(function (s) {
          openLabels.push(s.textContent.trim());
        });
        if (openLabels.length || root.querySelector('.ns-coll__facet')) {
          fresh.querySelectorAll('.ns-coll__facet').forEach(function (facet) {
            var label = facet.querySelector('.ns-coll__facet-summary span:first-child');
            if (!label) return;
            if (openLabels.indexOf(label.textContent.trim()) > -1) {
              facet.setAttribute('open', '');
            } else {
              facet.removeAttribute('open');
            }
          });
        }

        root.innerHTML = fresh.innerHTML;
        root.removeAttribute('aria-busy');

        // If the mobile drawer is open, keep focus inside it
        if (document.body.classList.contains('ns-coll-drawer-open')) {
          var closeBtn = root.querySelector('[data-ns-coll-drawer] .ns-coll__drawer-close');
          if (closeBtn) closeBtn.focus();
        }

        if (push) {
          history.pushState({ nsFacets: sectionId }, '', displayUrl);
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = displayUrl;
      });
  }

  function submitFilters(root) {
    var form = root.querySelector('[data-ns-coll-form]');
    if (!form) return;
    fetchAndSwap(root, serializeForm(form), true);
  }

  // ---- Filter inputs (checkboxes immediate, price debounced) ----
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-ns-coll-input]')) return;
    var root = getRoot(input);
    if (!root) return;
    if (input.type === 'number') {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () { submitFilters(root); }, 600);
    } else {
      submitFilters(root);
    }
  });

  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-ns-coll-input]') || input.type !== 'number') return;
    var root = getRoot(input);
    if (!root) return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(function () { submitFilters(root); }, 800);
  });

  // ---- Sort ----
  document.addEventListener('change', function (e) {
    var select = e.target;
    if (!select.matches || !select.matches('[data-ns-coll-sort]')) return;
    var root = getRoot(select);
    if (!root) return;
    var form = select.closest('form');
    fetchAndSwap(root, serializeForm(form), true);
  });

  // ---- Chip / pager / clear-all links: AJAX instead of navigation ----
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a.ns-coll__chip, a.ns-coll__pager-link, a[data-ns-coll-clear]') : null;
    if (!link) return;
    var root = getRoot(link);
    if (!root) return;
    var base = root.getAttribute('data-base-url') || window.location.pathname;
    var url;
    try { url = new URL(link.href, window.location.origin); } catch (err) { return; }
    if (url.pathname !== base) return; // external link (e.g. "Browse all clubs") — let it navigate
    e.preventDefault();
    fetchAndSwap(root, url.searchParams, true);
  });

  // ---- Back/forward ----
  window.addEventListener('popstate', function () {
    var root = pageRoot();
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    params.delete('section_id');
    fetchAndSwap(root, params, false);
  });

  // ---- Mobile drawer (open/close, Esc, backdrop, focus management) ----
  function drawerEl() {
    var root = pageRoot();
    return root ? root.querySelector('[data-ns-coll-drawer]') : null;
  }

  function openDrawer(opener) {
    lastFocusedOpener = opener || null;
    document.body.classList.add('ns-coll-drawer-open');
    var d = drawerEl();
    if (d) {
      var closeBtn = d.querySelector('.ns-coll__drawer-close');
      if (closeBtn) closeBtn.focus();
    }
  }

  function closeDrawer() {
    document.body.classList.remove('ns-coll-drawer-open');
    if (lastFocusedOpener && document.contains(lastFocusedOpener)) {
      lastFocusedOpener.focus();
    }
    lastFocusedOpener = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-ns-coll-drawer-open]') : null;
    if (opener) { openDrawer(opener); return; }
    var closer = e.target.closest ? e.target.closest('[data-ns-coll-drawer-close]') : null;
    if (closer) { closeDrawer(); }
  });

  document.addEventListener('keydown', function (e) {
    if (!document.body.classList.contains('ns-coll-drawer-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    // Basic focus trap inside the drawer
    var d = drawerEl();
    if (!d) return;
    var focusables = d.querySelectorAll('button, [href], input:not([disabled]), select, summary');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });
})();
